import React, { useRef, useState } from 'react';
import Footer from '../../components/Footer';
import Header from '../../components/Header';
import Lnb from '../../components/Lnb';
import Location from '../../components/Location';
import Paging from '../../components/Paging';
import useGetColumnList from '../../hooks/useGetColumnList';

const ColumnList: React.FC = () => {

    const [pageNum, setPageNum] = useState(1);
    const [searchKnd, setSearchKnd] = useState<string>('1');
    const inputValue = useRef<HTMLInputElement>(null);
    const [searchKeyword, setSearchKeyword] = useState<string>('');
    const { data, isLoading } = useGetColumnList(pageNum, searchKnd, searchKeyword);
    const formatingColumnContent = (content: string): string => {
        let replaceContent = content.replaceAll(/(<([^>]+)>)/ig, "").replaceAll("&nbsp;", "").replaceAll("  ", "").trim();
        return replaceContent.substring(0, 74) + '....';
    }

    const goPage = (pageNum: number): void => {
        if (pageNum === 0) {
            alert('다음 게시글이 없습니다.');
            return;
        } else {
            setPageNum(pageNum);
        }

        if (inputValue.current?.value) {
            setSearchKeyword(inputValue.current?.value)
        } else {
            setSearchKeyword('')
        }
    }

    const handleSelectChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        setSearchKnd(e.target.value);
    }

    const handleGoDetail = (contentSeq: number): void => {
        window.location.href=`/column/columnDetail/${contentSeq}`;
    }

    return (
        <div id="wrap">
            <Header />
            <section id="containers">
                <div className="therapy">
                    <Lnb />
                    <div id="contents" className='contents'>
                        <h2>전문심리칼럼</h2>
                        <Location locations={[{title: "토닥토닥마음케어", url: "/columnList"}]} menuName='전문심리칼럼'/>
                        <div className='mobileface infolist'>
                            <p className="green f18 lh24 mb30 bold">“매월 검증된 전문 심리 상담사의 칼럼을 확인해보세요"</p>
                            <fieldset className="searchbox">
                                <select title="검색분류선택" style={{marginRight: "10px"}} onChange={handleSelectChange}>
                                    <option value="1">제목</option>
                                    <option value="2">내용</option>
                                </select>
                                <input type="text" title="검색" ref={inputValue}/>
                                <button className="sm gray2" onClick={() => goPage(1)}>검색</button>
                            </fieldset>
                            <ul id="tablist" className="tablist mt20">
                                {
                                    isLoading && (<li>Loading.....</li>)
                                }
                                {
                                    !isLoading && data?.data.columnList && data?.data.columnList.length < 1 ? (
                                        <li>
										    등록된 내용이 없습니다.
									    </li>
                                    ) : (
                                        data?.data.columnList.map(column => (
                                            <li key={column.contentSeq}>
                                                <a href="#" onClick={() => handleGoDetail(column.contentSeq)}>
                                                    <dl>
                                                        <dt>{column.title}</dt>
                                                        <dd>{formatingColumnContent(column.content)}</dd>
                                                        <dd className="date">{column.regDate}</dd>
                                                    </dl>
                                                </a>
                                            </li>
                                        ))
                                    )
                                }
							</ul>
                            {
                                isLoading || !data?.data.columnList ? (
                                    <div></div>
                                ) : (
                                    <Paging 
                                        nowPage={data.data.pageInfo.nowPage}
                                        prevBlockNum={data.data.pageInfo.prevBlockNum}
                                        startBlock={data.data.pageInfo.startBlock}
                                        endBlock={data.data.pageInfo.endBlock}
                                        totBlock={data.data.pageInfo.totBlock}
                                        totPageSize={data.data.pageInfo.totPageSize}
                                        currentBlock={data.data.pageInfo.currentBlock}
                                        nextBlockNum={data.data.pageInfo.nextBlockNum}
                                        handlePage={goPage}
                                    />
                                )
                            }
                        </div>
                    </div>
                </div>
            </section>
            <Footer />
        </div>
    )
}

export default ColumnList;